<flowaccount-billing-for-wholesalers-section></flowaccount-billing-for-wholesalers-section>

<flowaccount-billing-benefit></flowaccount-billing-benefit>

<flowaccount-billing-form></flowaccount-billing-form>

<flowaccount-mobile-documents
  [heading]="'BILLING_NOTE_INVOICE.MOBILE_DOCUMENTS.HEADING'"
  [contentDocuments]="contentDocuments"
></flowaccount-mobile-documents>

<flowaccount-billing-video></flowaccount-billing-video>

<flowaccount-faq-accordion-squidex
  [contentSquidex]="'invoice-faq'"
  [contentScully]="'invoice-faq-key'"
></flowaccount-faq-accordion-squidex>

<flowaccount-content-call-to-action-squidex
  [contentCTA_1]="'CONTENT_CTA_SQUIDEX_INVOICE.HEADING_1'"
  [contentCTA_2]="'CONTENT_CTA_SQUIDEX_INVOICE.HEADING_2'"
  [contentTextLink]="'CONTENT_CTA_SQUIDEX_INVOICE.BUTTON_LINK'"
  [contentScully]="'CONTENT_CTA_FUNCTION_INVOICE'"
  [styleClass]="'function-invoice'"
  [previousPath]="signupPreviousPath.INVOICE"
>
</flowaccount-content-call-to-action-squidex>

<flowaccount-blog-swiper-squidex
  [lang]="translate.currentLang"
  [customHeader]="customHeader"
  [contentSquidex]="'invoice-blog'"
  [contentScully]="'invoice-blog-key'"
></flowaccount-blog-swiper-squidex>
